/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menudietvegetarian2Inputs */

const en_menudietvegetarian2 = /** @type {(inputs: Menudietvegetarian2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vegetarian`)
};

const de_menudietvegetarian2 = /** @type {(inputs: Menudietvegetarian2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vegetarisch`)
};

/**
* | output |
* | --- |
* | "vegetarian" |
*
* @param {Menudietvegetarian2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menudietvegetarian2 = /** @type {((inputs?: Menudietvegetarian2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menudietvegetarian2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menudietvegetarian2(inputs)
	return de_menudietvegetarian2(inputs)
});
export { menudietvegetarian2 as "menuDietVegetarian" }